import React, { PureComponent } from 'react';

import IconClose from '../icons/icon-close';

export default class Alert extends PureComponent {
    static defaultProps = {
        type: 'default',
        progress: 1
    }

    get icon() {
        if (this.props.noIcon) {
            return null;
        }

        if (this.props.icon) {
            return this.props.icon;
        }

        if (this.props.type === 'error') {
            return <i className="icon material-icons">error</i>;
        }

        if (this.props.progress !== 1) {
            return <i className="icon material-icons icon-animate-rotate">autorenew</i>;
        }

        if (this.props.type === 'success') {
            return <i className="icon material-icons">check_circle</i>;
        }

        return null;
    }

    render() {
        const classNames = [
            `alert-item`,
            `alert-item-type-${this.props.type}`
        ];

        if (this.props.manualClose) classNames.push('manual-close');
        if (this.props.visible) classNames.push('visible');
        if (this.props.collapsed) classNames.push('collapsed');
        if (this.props.progress > 0 && this.props.progress < 1) classNames.push('loading');
        if (this.props.className) classNames.push(this.props.className);

        return (
            <div className={classNames.join(' ')}>
                <span className="alert-item-progress" style={{ width: `${this.props.progress * 100}%` }} />

                <div className="alert-item-content">
                    { this.icon ? <div className="alert-item-icon">{ this.icon}</div> : null }

                    { this.props.children }
                </div>

                {
                    !this.props.noClose ? (
                        <span className="alert-item-close btn btn-small btn-simple-close" onClick={this.props.onClose}>
                            <IconClose />
                        </span>
                    ) : null
                }
            </div>
        );
    }
}
